module.exports = __webpack_public_path__ + "static/blog-1-3-b14b8ed8cbcc9b94cac15359dfead51b.jpg";